import React, { useState } from 'react';
import { Modal, Alert, Button } from 'antd';
import Form from '@rjsf/antd';
import validator from '@rjsf/validator-ajv8';
import { IChangeEvent } from '@rjsf/core';

export interface LabelCustomisationModalProps {
  visible: boolean;
  onCancel: () => void;
  onSubmit: (formData: any) => Promise<void>;
  initialData?: any;
  labelSchema: any;
  title: string;
}

const LabelCustomisationModal: React.FC<LabelCustomisationModalProps> = ({
  visible,
  onCancel,
  onSubmit,
  initialData,
  labelSchema,
  title,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async ({ formData }: IChangeEvent) => {
    try {
      setLoading(true);
      setError(null);
      await onSubmit(formData);
      onCancel();
    } catch (err: any) {
      if (err.graphQLErrors && err.graphQLErrors.length > 0) {
        setError(err.graphQLErrors[0].message);
      } else {
        setError(err.message || 'An unexpected error occurred during submission.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      title={title}
      footer={null}
      destroyOnClose
    >
      {error && (
        <Alert
          message="Submission Error"
          description={error}
          type="error"
          showIcon
          className="mb-4"
        />
      )}
      {labelSchema ? (() => {
        const uiSchema: any = {};
        const safeSchema = { ...labelSchema };
        delete safeSchema.$schema;

        if (safeSchema.properties) {
          Object.keys(safeSchema.properties).forEach((key) => {
            const prop = safeSchema.properties[key];
            if (prop && prop['ui:widget']) {
              uiSchema[key] = { 'ui:widget': prop['ui:widget'] };
            }
          });
        }
        
        return (
          <Form
            schema={safeSchema}
            uiSchema={uiSchema}
            validator={validator}
            formData={initialData}
            onSubmit={(e) => {
              console.log('onSubmit triggered', e);
              handleSubmit(e);
            }}
            onChange={(e) => console.log('onChange triggered', e)}
            onError={(errors) => console.log('onError triggered', errors)}
            disabled={loading}
            showErrorList={false}
            noHtml5Validate={true}
          >
            <div className="flex justify-end mt-4">
              <Button type="primary" htmlType="submit" loading={loading}>
                Submit
              </Button>
            </div>
          </Form>
        );
      })() : (
        <Alert message="No label schema configured for this company." type="warning" />
      )}
    </Modal>
  );
};

export default LabelCustomisationModal;
